import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getAdminMe } from '../../services/adminService';

function AdminProtectedRoute({ children }) {
  const [authState, setAuthState] = useState('checking');

  useEffect(() => {
    let isMounted = true;

    getAdminMe()
      .then(() => {
        if (isMounted) {
          setAuthState('authenticated');
        }
      })
      .catch(() => {
        if (isMounted) {
          setAuthState('unauthenticated');
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (authState === 'checking') {
    return (
      <div className="admin-shell">
        <div className="admin-auth-card">
          <p className="eyebrow">Admin</p>
          <h1>Checking session</h1>
        </div>
      </div>
    );
  }

  if (authState === 'unauthenticated') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

export default AdminProtectedRoute;
